import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

export default class lightbox {
  constructor(element) {
    this.element = element
    this.children = this.element.getElementsByClassName('lightbox__item')
    this.lightbox = document.getElementsByClassName('lightbox')[0]
    this.container = this.lightbox.getElementsByClassName('swiper-wrapper')[0]
    this.skipClickElements = [
      'swiper-button-next',
      'swiper-button-prev',
      'lightbox-close',
      'slide-wrapper-caption'
    ]
    this.attach()
  }

  attach() {
    for (let i = 0; i < this.children.length; i++) {
      this.children[i].addEventListener('click', this.open.bind(this, i))
    }
    this.lightbox
      .getElementsByClassName('lightbox-close')[0]
      .addEventListener('click', this.close.bind(this))
    document.addEventListener('keyup', this.listenToEscape.bind(this))
    this.lightbox.addEventListener('click', this.listenToOuterClick.bind(this))
  }

  listenToOuterClick(event) {
    let path = []

    if (!event.path) {
      var node = event.target
      while (node != document.body) {
        path.push(node)
        node = node.parentNode
      }
    } else {
      path = event.path
    }

    for (let element of path) {
      if (element.classList.contains('lightbox')) {
        break
      } else if (element.tagName === 'IMG') {
        return
      }
      for (let name of this.skipClickElements) {
        if (element.classList.contains(name)) {
          return
        }
      }
    }
    this.close()
  }

  listenToEscape(event) {
    switch (event.code) {
      case 'Escape':
        this.close()
        break
      case 'ArrowRight':
        this.swiper.slideNext()
        break
      case 'ArrowLeft':
        this.swiper.slidePrev()
        break
    }
  }

  open(index, event) {
    if (!(event.ctrlKey || event.metaKey)) {
      event.preventDefault()
      document.body.setAttribute(
        'class',
        document.body.getAttribute('class') + ' lightbox-visible'
      )
      this.build(index)
      document.body.setAttribute(
        'class',
        document.body.getAttribute('class') + ' lightbox-ready'
      )
    }
  }

  close() {
    document.body.setAttribute(
      'class',
      document.body
        .getAttribute('class')
        .replace('lightbox-visible', '')
        .replace('lightbox-ready', '')
        .trim()
    )
    if (this.swiper) {
      this.swiper.destroy()
    }
    this.container.innerHTML = ''
  }

  build(startIndex) {
    for (let i = 0; i < this.children.length; i++) {
      let child = this.children[i]

      let slide = document.createElement('div')
      let slideZoom = document.createElement('div')
      slide.setAttribute('class', 'swiper-slide')
      slideZoom.setAttribute('class', 'swiper-zoom-container')

      if (child.getAttribute('data-modal-type') == 'video') {
        slideZoom.appendChild(this.getVideoChild(child))
      } else {
        slideZoom.appendChild(this.getImageChild(child))
      }

      if (child.getAttribute('data-caption')) {
        let caption = document.createElement('div')
        caption.setAttribute(
          'class',
          'slide-wrapper-caption text-invert text-align-center'
        )
        caption.innerHTML = child.getAttribute('data-caption')
        slide.appendChild(caption)
      }

      slide.appendChild(slideZoom)
      this.container.appendChild(slide)
    }

    this.swiper = new Swiper('.lightbox-container', {
      initialSlide: startIndex,
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 30,
      zoom: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      wrapperClass: 'swiper-wrapper',

      pagination: {
        el: '.swiper-pagination'
      },
      modules: [Navigation, Pagination],
      on: {
        slideChange: () => {
          if (this.swiper && this.swiper.previousIndex) {
            let currentSlide = this.swiper.slides[this.swiper.previousIndex]
            let iframes = currentSlide.getElementsByTagName('iframe')
            if (iframes[0]) {
              let src = iframes[0].getAttribute('src')
              iframes[0].setAttribute('src', '')
              iframes[0].setAttribute('src', src)
            }
          }
        }
      }
    })
  }

  getVideoChild(child) {
    let video = document.createElement('div')
    video.setAttribute('class', 'video flex-center')
    let url = child.getAttribute('href')
    url = this.getYouTubeUrl(url) || this.getVimeoUrl(url)

    video.innerHTML = `
    <div >
        <iframe
          width="100%"
          height="100%"
          class="lightbox-video"
          src="${url}"
          frameborder="0"
          gesture="media"
          allow="encrypted-media"
          allowfullscreen>
          </iframe>
    </div>
    `

    return video
  }

  getImageChild(child) {
    let img = document.createElement('img')
    img.setAttribute('src', child.getAttribute('href'))
    return img
  }

  getVimeoUrl(url) {
    const match = url.match(/(videos|video|channels|\.com)\/([\d]+)/)
    if (match && match[2]) {
      return `https://player.vimeo.com/video/${match[2]}`
    } else {
      return null
    }
  }

  getYouTubeUrl(url) {
    const regExp =
      /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
    const match = url.match(regExp)
    if (match && match[7].length == 11) {
      return `https://www.youtube.com/embed/${match[7]}?rel=0`
    } else {
      return null
    }
  }
}
